const persona: Record<string, string> = {
  LANDLORD: 'landlord',
  RENTER: 'renter',
};

export default persona;
